module.exports = "<div id=\"grid-definitions\" class=\"h-100 ag-theme-balham\"></div>\n";